"use client";

// global-error.tsx is the LAST line of defense — it catches errors thrown in
// the root layout itself (RootLayout, Providers, ConnectPopupBridge) which no
// other boundary can reach. It replaces the whole document, so it must render
// its own <html>/<body> and cannot rely on the app's global CSS being present.

import { useEffect } from "react";
import { reportError } from "@/lib/observability";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError(error, { scope: "global-error", digest: error.digest });
  }, [error]);

  return (
    <html lang="en">
      <body>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "1rem",
            fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          }}
        >
          <div style={{ maxWidth: 440, textAlign: "center" }}>
            <h1 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: "0.5rem" }}>
              Something went wrong
            </h1>
            <p style={{ color: "#6b7280", lineHeight: 1.5, marginBottom: "1.5rem" }}>
              The application hit an unexpected error and couldn't recover on its own. Our team has
              been notified.
              {error.digest ? ` (Ref: ${error.digest})` : ""}
            </p>
            <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
              <button
                type="button"
                onClick={reset}
                style={{
                  padding: "0.6rem 1.25rem",
                  borderRadius: 8,
                  border: "1px solid #111827",
                  background: "#111827",
                  color: "#fff",
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
              >
                Try again
              </button>
              <button
                type="button"
                onClick={() => {
                  window.location.href = "/notes";
                }}
                style={{
                  padding: "0.6rem 1.25rem",
                  borderRadius: 8,
                  border: "1px solid #d1d5db",
                  background: "#fff",
                  color: "#374151",
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
              >
                Go to Notes
              </button>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
